import { get } from 'lodash'

export const AD_STATUS = Object.freeze({
    SOLD: 'SOLD',
    FORSALE: 'FORSALE',
    EXPIRED: 'EXPIRED',
    REMOVED: 'REMOVED',
})

export const AD_DRAFT_STATUS = Object.freeze({
    NONE: 'none',
    DRAFT_EXISTS: 'draft_exists',
    AD_EXISTS: 'ad_exists',
})

export const getAdTitle = (ad) => {
    // try to read model from ad.model.name and then ad.model as it differs based on vertical
    const make = get(ad, 'make.name', get(ad, 'make', ''))
    const model = get(ad, 'model.name', get(ad, 'model', ''))
    const safeRegNumber = get(ad, 'safeRegNumber', '')

    return `${make}${model ? ` ${model}` : ''}${safeRegNumber ? `, ${safeRegNumber}` : ''}`
}
